const ITEMS = [
  "Nutrizione personalizzata",
  "Biologa Nutrizionista",
  "Salerno",
  "Composizione corporea · BIA",
  "Consulenze online",
  "Piani alimentari su misura",
];

function Diamond() {
  return (
    <span aria-hidden="true" className="mx-6 lg:mx-10 inline-block w-2 h-2 rotate-45 bg-taupe/70 shrink-0" />
  );
}

export default function Marquee({ dark = false }) {
  return (
    <div
      aria-label="K Nutrition in breve"
      className={`overflow-hidden border-y ${
        dark ? "bg-charcoal text-ivory border-taupe/25" : "bg-peach text-deeptaupe border-taupe/30"
      } py-5 lg:py-7`}
      data-testid="marquee-band"
    >
      <div className="marquee-track items-center">
        {[0, 1].map((copy) => (
          <div aria-hidden={copy === 1} key={copy} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center font-display italic text-2xl lg:text-4xl whitespace-nowrap">
                {item}
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
